import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TeamContext, UserContext } from "../../../context";
import { useSound } from "../../../hooks";
import { InitialDeck } from "../../molecules";

const InitialDeckScreen = () => {
    const { t } = useTranslation();
    const { game } = useContext(TeamContext);
    const { userData } = useContext(UserContext);
    const didUserDrawnAllSolutionCards: boolean = game?.gameInfo.players[userData?.email || ""]?.hasDrawnSolutionCards;
    const {playSound} = useSound();

    useEffect(() => {
        playSound("/sounds/PositiveAlert3.mp3")

    },[playSound]);

    return (
        <div className="initial_deck_screen_wrapper center_horizontally_and_vertically" style={{ width: "100vw", height: "100vh" }}>
            <div className="initial_deck_screen_components_order">
                <div className="initial_deck_screen_component_notification vertically_end">
                    <div className="full_width">
                        <div className="full_width title center_horizontally animation_ripple animation_ripple_delay_2">
                            {t("nowYouWillGetYourInitialSolutionCardsText")}
                        </div>
                        <div className="gradient_line_holder center_horizontally_and_vertically animation_ripple animation_ripple_delay_4">
                            <div className="linear_gradient_line_horizontal" style={{ width: "50%" }}></div>
                        </div>
                        {didUserDrawnAllSolutionCards ?
                            <div className="full_width instruction animation_ripple animation_ripple_delay_6">
                                <div className="notificatoin_wrapper"> {t("waitForOtherPlayersToPickTheirCardsText")} </div>
                            </div>
                            :
                            <div className="full_width instruction animation_ripple animation_ripple_delay_6">
                                <p>{t("theCardsWillBeDrawnAutomaticallyText")}</p>
                                <p>{t("thereAre4TypesOfPositiveSolutionsText")}</p>
                            </div>}
                    </div>
                </div>
                <div className="initial_deck_screen_component_decks center_horizontally_and_vertically">
                    <InitialDeck />
                </div>
                <div className="initial_deck_screen_component_bottom center_horizontally_and_vertically"> </div>
            </div>

        </div>
    )
}

export default InitialDeckScreen;